/**
 * Build a public S3 URL for a theme asset filename.
 * Passes through values that are already absolute URLs.
 */
export function s3PublicUrl(asset) {
  if (asset == null || asset === "") return "";
  const s = String(asset).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const baseRaw =
    process.env.REACT_APP_S3_PATH || process.env.REACT_APP_S3_SOURCE || "";
  if (!baseRaw) return s.replace(/^\/+/, "");
  const normalizedBase = baseRaw.endsWith("/") ? baseRaw : `${baseRaw}/`;
  return normalizedBase + s.replace(/^\/+/, "");
}
